import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiRest } from "../api/constants";
import { logOut } from "../api/login";
import { setAlert, setLogoutPending, setUserLogOut } from "../reducers/userConfigSlice";

export const LOGOUT_EVENT_KEY = `delibran:superadmin:logout:${apiRest}`;

export const useLogoutSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const onStorage = (event) => {
      if (event.storageArea !== window.localStorage || event.key !== LOGOUT_EVENT_KEY || !event.newValue || event.newValue === event.oldValue) return;
      dispatch(setUserLogOut());
      navigate("/", { replace: true });
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch, navigate]);
};

export const useLogout = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const navigate = useNavigate();
  const loggingOut = useSelector((state) => state.aplicationConfig.userConfig.logoutPending);
  const logout = async () => {
    // Redux updates synchronously, including controls rendered in another menu.
    if (store.getState().aplicationConfig.userConfig.logoutPending) return;
    dispatch(setLogoutPending(true));
    try {
      const response = await logOut();
      if (response?.error !== false) throw new Error("Logout failed");
      dispatch(setUserLogOut());
      try {
        window.localStorage.setItem(LOGOUT_EVENT_KEY, `${Date.now()}:${Math.random()}`);
      } catch {
        // The server session is revoked even when browser storage is unavailable.
      }
      navigate("/", { replace: true });
    } catch {
      dispatch(setAlert({ called: true, type: "error", title: "No se pudo cerrar la sesión", message: "Comprueba la conexión y vuelve a intentarlo. La sesión sigue abierta." }));
    } finally {
      dispatch(setLogoutPending(false));
    }
  };
  return { logout, loggingOut };
};
